import { render, staticRenderFns } from "./EditOrderAddon.vue?vue&type=template&id=0ba70940&scoped=true&"
import script from "./EditOrderAddon.vue?vue&type=script&lang=js&"
export * from "./EditOrderAddon.vue?vue&type=script&lang=js&"
import style0 from "./EditOrderAddon.vue?vue&type=style&index=0&id=0ba70940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba70940",
  null
  
)

export default component.exports